<template>
<div class="inSite" v-if="otp">

    <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!--     <VueCountdown :time="$CAMPAIGN.expire_otp * 60 * 1000" @end="otpEndTime" ><template slot-scope="props">เหลือ {{ props.minutes }}:{{ props.seconds }} นาที</template> </VueCountdown> -->
    <VueCountdown :time="sms.expire_otp * 60 * 1000" @end="otpEndTime"></VueCountdown>
 
    <div class="text-center confirmBox animate__animated animate__zoomIn" >
        <div class="cTopic">{{title}}</div> 

        <div class="pls">กรุณากรอก OTP ที่ได้รับ</div>
        <div class="otpBox">
            <OtpInput ref="otpInput" input-classes="otp-input" separator="" :num-inputs="6" :should-auto-focus="true" :is-input-num="true" @on-change="handleOnChange" @on-complete="handleOnComplete" />
        </div>
        <div class="alert mt-2" v-if="alertText" :class="alertClass">
            {{alertText}}
        </div>
        <v-btn class="ma-2 mt-5" :disabled="disabled" outlined color="blue darken-3" small v-if="btn" @click="reSendOtp()">
            <span v-if="disabled">
                (<VueCountdown :time="60000" @end="onCountdownButtonEnd">
                    <template slot-scope="props"> {{ props.seconds }} </template>
                </VueCountdown>)</span>
            ขอรหัส OTP อีกครั้ง
        </v-btn>

    </div>

</div>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';
import OtpInput from "@bachdgvn/vue-otp-input";

export default {

    components: {
        OtpInput,
        VueCountdown
    },
    props: {
        title:null,
        item: null,
        sms:null,
        otp:null
    },

    data: () => ({
        overlay: null,
        btn: true,
        alertText: null,
        alertClass: null,
        disabled: true, 
        register: null,
        model: null,
        color: null,

    }),

    computed: {

    },

    watch: {

    },
    methods: {
        reSendOtp(){

            this.disabled = true
            this.$emit('reSend',true)

        },

        otpEndTime() {
            this.$emit('endTime', true)
        },

        onCountdownButtonEnd() {
            console.log('END')
            this.disabled = false
        },

        handleOnComplete(value) {
            console.log('OTP completed: ', value);
            console.log(this.otp );

            if (this.otp == value) {

                this.btn = null

                this.$emit('confirm', true)
                  console.log('true');

            } else {
                this.alertClass = 'animate__animated animate__shakeX';
                this.alertText = 'รหัส OTP ไม่ถูกต้องค่ะ'
            }

        },
        handleOnChange(value) {
            console.log('OTP changed: ', value);
            this.alertClass = null;
            this.alertText = null
        },
        handleClearInput() {
            this.$refs.otpInput.clearInput();
        },

      

    },
    created() {

        this.disabled = true

    },
};
</script>
